/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
// import NewTable from '../../components/NewTable/NewTable'
import ContactUs from '../ContactUs/ContactUs';

const CsEmail = () => {
  // const [csEmailData, setCsEmailData] = useState([])
  // const dummySwapData = [
  //   {
  //     id: "Dummy",
  //     subject: "Dummy",
  //     engineerType: "Dummy",
  //     complaintType: "Dummy",
  //     productSno: "Dummy",
  //     dateAndTime: "Dummy",
  //     status: "Dummy"
  //   },
  //   {
  //     id: "Dummy",
  //     subject: "Dummy",
  //     engineerType: "Dummy",
  //     complaintType: "Dummy",
  //     productSno: "Dummy",
  //     dateAndTime: "Dummy",
  //     status: "Dummy"
  //   },
  //   {
  //     id: "Dummy",
  //     subject: "Dummy",
  //     engineerType: "Dummy",
  //     complaintType: "Dummy",
  //     productSno: "Dummy",
  //     dateAndTime: "Dummy",
  //     status: "Dummy"
  //   },
  //   {
  //     id: "Dummy",
  //     subject: "Dummy",
  //     engineerType: "Dummy",
  //     complaintType: "Dummy",
  //     productSno: "Dummy",
  //     dateAndTime: "Dummy",
  //     status: "Dummy"
  //   },

  //   {
  //     id: "Dummy",
  //     subject: "Dummy",
  //     engineerType: "Dummy",
  //     complaintType: "Dummy",
  //     productSno: "Dummy",
  //     dateAndTime: "Dummy",
  //     status: "Dummy"
  //   },
  //   {
  //     id: "Dummy",
  //     subject: "Dummy",
  //     engineerType: "Dummy",
  //     complaintType: "Dummy",
  //     productSno: "Dummy",
  //     dateAndTime: "Dummy",
  //     status: "Dummy"
  //   },
  //   {
  //     id: "Dummy",
  //     subject: "Dummy",
  //     engineerType: "Dummy",
  //     complaintType: "Dummy",
  //     productSno: "Dummy",
  //     dateAndTime: "Dummy",
  //     status: "Dummy"
  //   },

  //   {
  //     id: "Dummy",
  //     subject: "Dummy",
  //     engineerType: "Dummy",
  //     complaintType: "Dummy",
  //     productSno: "Dummy",
  //     dateAndTime: "Dummy",
  //     status: "Dummy"
  //   }
  // ];

  // useEffect(() => {
  //   setCsEmailData(dummySwapData);
  // }, []);



  const statusCards = [
    {
      title: 'Created',
      count: 50,
      icon: (
        <img src='/csemail/07 Writing Idea.png' alt='wri' className='w-8 h-8' />
      ),
      bgColor: 'bg-pink-100',
      textColor: 'text-pink-500'
    },
    {
      title: 'Unassigned',
      count: 0,
      icon: (
        <img src='/csemail/fi_9859670.png' alt='wri' className='w-8 h-8' />
      ),
      bgColor: 'bg-blue-100',
      textColor: 'text-blue-500'
    },
    {
      title: 'Open',
      count: 20,
      icon: (
        <img src='/csemail/Frame.png' alt='wri' className='w-8 h-8' />
      ),
      bgColor: 'bg-indigo-100',
      textColor: 'text-indigo-500'
    },
    {
      title: 'Solved',
      count: 10,
      icon: (
        <img src='/csemail/fi_2896405.png' alt='wri' className='w-8 h-8' />
      ),
      bgColor: 'bg-red-100',
      textColor: 'text-red-500'
    }
  ];
  const shortcutCards = [
    {
      title: 'Users',
      count: 50,
      icon: (
        <img src='/csemail/fi_615075.png' alt='wri' />
      ),
      bgColor: 'bg-purple-100',
      textColor: 'text-purple-500'
    },
    {
      title: 'Complaints',
      count: 0,
      icon: (
        <img src='/csemail/fi_1450932.png' alt='wri' className='w-8 h-8' />
      ),
      bgColor: 'bg-green-100',
      textColor: 'text-green-500'
    },
    {
      title: 'Customers',
      count: 20,
      icon: (
        <img src='/csemail/fi_6012670.png' alt='wri' className='w-8 h-8' />
      ),
      bgColor: 'bg-orange-100',
      textColor: 'text-orange-500'
    },
    {
      title: 'Products',
      count: 10,
      icon: (
        <img src='/csemail/fi_7078329.png' alt='wri' className='w-8 h-8' />
      ),
      bgColor: 'bg-pink-100',
      textColor: 'text-pink-500'
    }
  ];
  const StatCard = ({ title, count, icon, bgColor, textColor }) => (
    <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
      <div>
        <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
        <p className="text-2xl font-bold text-gray-900">{count}</p>
      </div>
      <div className={`${bgColor} ${textColor} p-4 rounded-full`}>
        {icon}
      </div>
    </div>
  );


  // const tableHeadings = ['ID', 'Subject', 'Engineer Status', 'Complaint Type', 'Product S.No', 'Opened Since', 'Date&Time']
  // const tableRows = csEmailData?.map((ele, index) => [
  //   ele?.id,
  //   ele?.subject,
  //   ele?.engineerType,
  //   ele?.complaintType,
  //   ele?.productSno,
  //   ele?.dateAndTime,
  //   ele?.status
  // ])




  return (
    <div className='p-4'>
      <div className="p-6 bg-gray-50">
        <h1 className="mb-6 text-2xl font-bold text-gray-800">Complaint & Disputes</h1>

        <div className="grid grid-cols-1 gap-6 mb-8 md:grid-cols-2 lg:grid-cols-4">
          {statusCards.map((card, index) => (
            <StatCard key={`status-${index}`} {...card} />
          ))}
        </div>

        {/* Shortcuts Section */}
        <h2 className="mb-4 text-xl font-bold text-gray-800">Shortcuts</h2>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
          {shortcutCards.map((card, index) => (
            <StatCard key={`shortcut-${index}`} {...card} />
          ))}
        </div>
      </div>
      <div className='h-[430px] overflow-hidden overflow-y-auto'>
        <ContactUs />
      </div>
    </div>
  )
}

export default CsEmail